import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Message, Animation, } from 'rsuite';
import moment from 'moment'
import 'moment/locale/fa' 
moment.locale('fa')


function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}

export class Notfy extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            notfy: null
        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount() {


        Send('page/notfy', null, true).then((res) => {
            this.setState({ notfy: res.data.notfy });
        }).catch((err) => { });

    }



    render() {

        H1.page_name("پیام ها");



        return this.state.notfy !== null && (




            <div className="h-100 mt-4">
                <div className='c-row'>
                    <div className="text-center mb-2 py-2 position-relative">
                        <span className='fs-6'>اعلان‌ها</span>
                    </div>
                </div>


                <Animation.Slide in={true} placement="right">

                <div className="c-row text-center mt-4">


                    {this.state.notfy === false &&

                        <Message showIcon type="info">
                            اعلانی برای شما وجود ندارد.
                        </Message>
                    }

                    {this.state.notfy &&

                            this.state.notfy.map((item, index) => [
                                <div className='notfy_box d-flex mt-3' key={index}>
                                    <div className='me-3'>




                                        {item.type === 'a' ?

                                        <span className="icon-Done ico type_a"></span>

                                        :item.type === 'e' ?

                                        <span className="icon-Close ico type_e"></span>

                                        :
                                        <span className="icon-Courses ico type_n"></span>
                                        }

                                    </div>
                                    <div className='dis text-start'>{item.dis}
                                        <div className='mt-2 fs-12 cc-2'>
                                        {moment(item.created_at).fromNow()}
                                            </div>
                                    </div>
                                </div>
                            ])

                    }

                </div>

                </Animation.Slide>

            </div>


        )
    }
}

export default withParams(Notfy);
